module.exports = "https://files.cnvos.lb.djnd.si/static/images/doodle_dobra-vecerja-1.png?76ebe7a3068e7c389c005bb84b147b00";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodle_dobra-vecerja-1.png
// module id = 117
// module chunks = 1 2